import React, {FC, ReactElement} from "react";
import {getColorForLevel, InvoiceReviewProblem, ReviewProblemLevel} from "../../../model/invoice/InvoiceReviewProblem";
import {Grid, Paper, Typography} from "@mui/material";
import {DetailPanel} from "material-table";

interface IProps {
    problems: InvoiceReviewProblem[]
}

const sortProblems = (a: InvoiceReviewProblem, b: InvoiceReviewProblem) => {
    if (a.level === b.level) {
        return a.category > b.category ? 1 : -1;
    }
    return a.level > b.level ? 1 : -1;
};

const ReviewProblemDetails: FC<IProps> = ({problems = []}): ReactElement => {
    return <Paper elevation={1} style={{marginBottom: "0.1rem"}}>
        <Grid container>{
            problems.sort(sortProblems).map(problem =>
                <Grid item container xs={12} style={{backgroundColor: getColorForLevel(problem.level)}}>
                    <Typography variant={"body2"} style={{marginLeft: "0.3rem"}}>
                        {problem.category} - {problem.description}
                    </Typography>
                </Grid>
            )
        }
        </Grid>
    </Paper>
};

export const buildReviewProblemDetails = (problems: InvoiceReviewProblem[]) => {
    return {
        disabled: !problems || problems.length === 0,
        render: () => <ReviewProblemDetails problems={problems}/>
    } as DetailPanel<any>
}

export const reviewProblemRowStyle = (problems: InvoiceReviewProblem[]): React.CSSProperties => {
    if (problems) {
        if (problems.find(it => it.level === ReviewProblemLevel.ERROR)) {
            return {backgroundColor: getColorForLevel(ReviewProblemLevel.ERROR)}
        }
        if (problems.find(it => it.level === ReviewProblemLevel.WARNING)) {
            return {backgroundColor: getColorForLevel(ReviewProblemLevel.WARNING)}
        }
    }
    return {};
}